// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const MessagingSettings = {
    /**
     * Get a Setting
     */
    Get(fn, req) {
        return fn(`/messaging/settings/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Set will upsert a Setting, update the setting history, and return the new setting.
     * Partial updates to the setting data can be made by providing a mask.
     * Suggested reading on field masks: https://protobuf.dev/reference/protobuf/google.protobuf/#field-mask
     */
    Set(fn, req) {
        return fn(`/messaging/settings/v1`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Revert will reset a setting to its default value.
     * Future calls to get the setting will reture nil or the default setting if there is one.
     */
    Revert(fn, req) {
        return fn(`/messaging/settings/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * History will return the history of a setting including the current setting.
     */
    History(fn, req) {
        return fn(`/messaging/settings/v1/history?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * List all settings of a give setting type for an org filtering by user, locations, and assets.
     * Only setting values that have been set will be returned. Default settings will not be returned.
     */
    List(fn, req) {
        return fn(`/messaging/settings/v1/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Types will return configurations for each setting type that is available to be set.
     */
    Types(fn, req) {
        return fn(`/messaging/settings/v1/types?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
